// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-not-found {
  align-items: center;
  min-height: 377px;
  gap: 5%;
  display: flex;
  height: calc(100vh - 433px);
  padding: 111px 14%;
  justify-content: center;
}
.page-not-found-left {
  margin-top: 26px;
}
.page-not-found-left h1 {
  font-size: 46px;
  width: 82%;
  font-weight: 500;
  line-height: 50px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.page-under-construction-left h1 {
  display: flex;
  flex-direction: column;
  line-height: 50px;
  width: 100%;
}
.page-not-found-left span {
  font-weight: 700;
  color: var(--orange);
}
.page-not-found-left p {
  font-size: 22px;
  font-weight: 500;
  line-height: 34px;
  margin-top: 20px;
  margin-bottom: 100px;
}
.page-not-found-left a {
  font-size: 22px;
  font-weight: 500;
  line-height: 50px;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  color: #000;
}
.page-not-found-left a span {
  color: var(--orange);
}
.page-not-found-right {
}

@media (max-width: 1220px) {
  .page-not-found {
    flex-direction: column-reverse;
    min-height: 763px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/errorPage/errorPage.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,OAAO;EACP,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;AACA;;AAEA;EACE;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;AACF","sourcesContent":[".page-not-found {\n  align-items: center;\n  min-height: 377px;\n  gap: 5%;\n  display: flex;\n  height: calc(100vh - 433px);\n  padding: 111px 14%;\n  justify-content: center;\n}\n.page-not-found-left {\n  margin-top: 26px;\n}\n.page-not-found-left h1 {\n  font-size: 46px;\n  width: 82%;\n  font-weight: 500;\n  line-height: 50px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n.page-under-construction-left h1 {\n  display: flex;\n  flex-direction: column;\n  line-height: 50px;\n  width: 100%;\n}\n.page-not-found-left span {\n  font-weight: 700;\n  color: var(--orange);\n}\n.page-not-found-left p {\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 34px;\n  margin-top: 20px;\n  margin-bottom: 100px;\n}\n.page-not-found-left a {\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 50px;\n  text-align: left;\n  cursor: pointer;\n  text-decoration: none;\n  color: #000;\n}\n.page-not-found-left a span {\n  color: var(--orange);\n}\n.page-not-found-right {\n}\n\n@media (max-width: 1220px) {\n  .page-not-found {\n    flex-direction: column-reverse;\n    min-height: 763px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
